import { Menu } from "./menu";

export abstract class EuMenuService {

    appMenus: Menu[]

    constructor(public http: any) { }

    abstract getApplicationMenus(fetch?: boolean): Promise<Menu[]>

}